import { capitalize, formatInTZ, formatLocale } from './locale'

/** The day of an agenda item as the detail screens print it, e.g. "Do 09/09/2026". */
function formatAgendaDate(start: string | Date): string {
  return capitalize(formatLocale(new Date(start), 'EEEEEE dd/MM/yyyy'))
}

/** The hour of an agenda item in the hospital's time zone, e.g. "07:30". */
function formatAgendaTime(start: string | Date): string {
  return formatInTZ(new Date(start), 'HH:mm')
}

export { formatAgendaDate, formatAgendaTime }
